// Permisos del usuario, tal y como los devuelve el back en loginAzure y en
// /employee/me: [{ id, name }]. Ocultar algo en la UI no basta: el back
// es quien decide y puede responder 403 igualmente.

export type Permission = { id: number; name: string };

export const MANAGE_USERS = "gestionar_usuarios";

export const validatePermission = (permissions: Permission[] | null | undefined, name: string) =>
  (permissions ?? []).some((permission) => permission?.name === name);

// Nombre legible: "gestionar_usuarios" -> "Gestionar usuarios"
export const permissionLabel = (name: string) => {
  const text = String(name ?? "").replace(/_/g, " ").trim();
  return text.charAt(0).toUpperCase() + text.slice(1);
};
